import { get, noop } from 'lodash';
import update from 'immutability-helper';
import { useDashboardStore } from './dashboard';
import { useMemo } from 'react';

export const QueryStatusHandle = (wid) => {
  const updateState = (num) =>
    useDashboardStore.setState((state) => {
      const widCount = get(state, ['queryManager', 'status', wid], 0);
      return update(state, {
        queryManager: {
          status: {
            $merge: { [wid]: Math.max(widCount + num, 0) },
          },
        },
      });
    });

  return {
    inc: () => updateState(1),
    dec: () => updateState(-1),
    reset: () => updateState(0),
    // log: () => console.log(useDashboardStore.getState().queryManager.status),
  };
};

export const clearQueryQueue = () => {
  const { queryManager } = useDashboardStore.getState();
  queryManager.concurrencyLimiter.clearQueue();
};

// queue status
// loading status is covered by react query
export const useWidgetQueryStatus = (wid) => {
  const status = useDashboardStore((state) => state.queryManager.status);
  const queued = useMemo(() => {
    const queryCount = get(status, [wid], 0);
    return queryCount > 0;
  }, [status, wid]);

  return { queued };
};

export const qetQueryManager = (wid) => {
  const { queryManager } = useDashboardStore.getState();
  const qh = QueryStatusHandle(wid);

  let cancelQuery: any = null;

  const abort = () => {
    try {
      // if there is an active query
      if (cancelQuery) {
        cancelQuery();
        qh.dec();
      }
    } catch (err) {
      //ignore
    }
  };

  const exec = async (fn) => {
    abort();

    // add query to queue
    qh.inc();
    const { response, cancel } = queryManager.concurrencyLimiter(() => {
      qh.dec(); // switch to react query indicator
      return fn();
    });

    cancelQuery = cancel;
    const responseData = await response;
    cancelQuery = null;
    return responseData;
  };

  return {
    exec,
    abort,
  };
};
